import { ILangText } from "../ILangText";


const labels:{ [k:string]:ILangText }  = { }

const actions:{ [k:string]:ILangText }  = {
	"understood":{
		en:"I Understand",
		is:"Ég skil"
	},
	"cancel":{
		en:"Cancel",
		is:"Hætta við"
	},
	"submit":{
		en:"Submit",
		is:"Staðfesta"
	},
	"done":{
		en:"Done",
		is:"Búin(n)"
	},
	"confirm":{
		en:"Confirm",
		is:"Staðfesta"
	},
	"confirmAndCreate":{
		en:"Confirm & Create",
		is:"Staðfesta og búa til"
	},
	"confirmAndClose":{
		en:"Confirm and Close",
		is:"Staðfesta og loka",
	},
}

const messages:{ [k:string]:ILangText }  = {
	"irreversible":{
		en:"Are you sure? This is irreversible.",
		is:"Ertu viss? Þetta getur ekki verið endurkallað."
	},
};

const prompts:{ [k:string]:ILangText }  = {};
Object.keys(labels).forEach(k => prompts[`prompts.label.${k}`] = labels[k]);
Object.keys(actions).forEach(k => prompts[`prompts.action.${k}`] = actions[k]);
Object.keys(messages).forEach(k => prompts[`prompts.message.${k}`] = messages[k]);
export { prompts };